define('responsive-game-feed/app/scripts/views/Scout',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','../views/PitchesDisplay','../utils/HotColdUtils','gameday-language/gameday-language'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var PitchesDisplay = require("../views/PitchesDisplay");
    var HotColdUtils = require("../utils/HotColdUtils");
    var gamedayLanguage = require("gameday-language/gameday-language");
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function ScoutView(cfg) {
       this.element = cfg.element;
    }

    ScoutView.prototype = {
        
        getHotColdColor: function(zone) {
		        return HotColdUtils.getHotZoneColorClass(parseFloat(zone.sweetness), "b");
		},
		
		updateSingleField: function (elementID, content, css) {
				this.element.find(elementID).html(content);
				
				if (css != null) {
					this.element.find(elementID).removeClass(this.element.find(elementID).attr("class"));
					this.element.find(elementID).addClass(css);
				}
		},
		
		clearStrikezone: function() {
		        for (var i = 0; i < 13; i++) {
		            var zoneID = "#pitches_hotCold_zone" + i;
		            $(zoneID).removeClass($(zoneID).attr("class"));
		        }
		},
			
        render: function(cfg) {
           var that = this;
           var model = cfg.model;
           var hotColdData = (typeof model.data.hotColdZone !== 'undefined' && typeof model.data.hotColdZone.std !== 'undefined')  ? model.data.hotColdZone.std : undefined;
           var template = hogan.compile(cfg.template); 
           var html = template.render({model :model, mustacheLanguage : gamedayLanguage(Utils.options.language)});
                
           
           var tally = 0;
            
           for (var i = 0; i < 9; i++) {
                if (hotColdData && hotColdData.sit) {
                 this.updateSingleField("#pitches_hotCold_zone" + i, hotColdData.sit.zone[i].rating, this.getHotColdColor(hotColdData.sit.zone[i]));
                 if (isNaN(hotColdData.sit.zone[i].sweetness)) tally++;
                }
            }
            //if (tally == 13) this.clearStrikezone();
		    $(cfg.feedView).trigger("renderCBTracker_"+cfg.model.guid, cfg.model.guid);
            
        }
    }    
    
    
    return ScoutView;

});
